(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
!function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).LazyLoad=t()}(this,(function(){"use strict";function n(){return n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n},n.apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),a=t&&window.devicePixelRatio>1,r={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1},c=function(t){return n({},r,t)},u=function(n,t){var e,i="LazyLoad::Initialized",o=new n(t);try{e=new CustomEvent(i,{detail:{instance:o}})}catch(n){(e=document.createEvent("CustomEvent")).initCustomEvent(i,!1,!1,{instance:o})}window.dispatchEvent(e)},l="src",s="srcset",f="sizes",d="poster",_="llOriginalAttrs",g="loading",v="loaded",b="applied",p="error",h="native",m="data-",E="ll-status",I=function(n,t){return n.getAttribute(m+t)},y=function(n){return I(n,E)},A=function(n,t){return function(n,t,e){var i="data-ll-status";null!==e?n.setAttribute(i,e):n.removeAttribute(i)}(n,0,t)},k=function(n){return A(n,null)},L=function(n){return null===y(n)},w=function(n){return y(n)===h},x=[g,v,b,p],O=function(n,t,e,i){n&&(void 0===i?void 0===e?n(t):n(t,e):n(t,e,i))},N=function(n,t){o?n.classList.add(t):n.className+=(n.className?" ":"")+t},C=function(n,t){o?n.classList.remove(t):n.className=n.className.replace(new RegExp("(^|\\s+)"+t+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},M=function(n){return n.llTempImage},z=function(n,t){if(t){var e=t._observer;e&&e.unobserve(n)}},R=function(n,t){n&&(n.loadingCount+=t)},T=function(n,t){n&&(n.toLoadCount=t)},G=function(n){for(var t,e=[],i=0;t=n.children[i];i+=1)"SOURCE"===t.tagName&&e.push(t);return e},D=function(n,t){var e=n.parentNode;e&&"PICTURE"===e.tagName&&G(e).forEach(t)},V=function(n,t){G(n).forEach(t)},F=[l],j=[l,d],P=[l,s,f],S=function(n){return!!n[_]},U=function(n){return n[_]},$=function(n){return delete n[_]},q=function(n,t){if(!S(n)){var e={};t.forEach((function(t){e[t]=n.getAttribute(t)})),n[_]=e}},H=function(n,t){if(S(n)){var e=U(n);t.forEach((function(t){!function(n,t,e){e?n.setAttribute(t,e):n.removeAttribute(t)}(n,t,e[t])}))}},B=function(n,t,e){N(n,t.class_loading),A(n,g),e&&(R(e,1),O(t.callback_loading,n,e))},J=function(n,t,e){e&&n.setAttribute(t,e)},K=function(n,t){J(n,f,I(n,t.data_sizes)),J(n,s,I(n,t.data_srcset)),J(n,l,I(n,t.data_src))},Q={IMG:function(n,t){D(n,(function(n){q(n,P),K(n,t)})),q(n,P),K(n,t)},IFRAME:function(n,t){q(n,F),J(n,l,I(n,t.data_src))},VIDEO:function(n,t){V(n,(function(n){q(n,F),J(n,l,I(n,t.data_src))})),q(n,j),J(n,d,I(n,t.data_poster)),J(n,l,I(n,t.data_src)),n.load()}},W=["IMG","IFRAME","VIDEO"],X=function(n,t){!t||function(n){return n.loadingCount>0}(t)||function(n){return n.toLoadCount>0}(t)||O(n.callback_finish,t)},Y=function(n,t,e){n.addEventListener(t,e),n.llEvLisnrs[t]=e},Z=function(n,t,e){n.removeEventListener(t,e)},nn=function(n){return!!n.llEvLisnrs},tn=function(n){if(nn(n)){var t=n.llEvLisnrs;for(var e in t){var i=t[e];Z(n,e,i)}delete n.llEvLisnrs}},en=function(n,t,e){!function(n){delete n.llTempImage}(n),R(e,-1),function(n){n&&(n.toLoadCount-=1)}(e),C(n,t.class_loading),t.unobserve_completed&&z(n,e)},on=function(n,t,e){var i=M(n)||n;nn(i)||function(n,t,e){nn(n)||(n.llEvLisnrs={});var i="VIDEO"===n.tagName?"loadeddata":"load";Y(n,i,t),Y(n,"error",e)}(i,(function(o){!function(n,t,e,i){var o=w(t);en(t,e,i),N(t,e.class_loaded),A(t,v),O(e.callback_loaded,t,i),o||X(e,i)}(0,n,t,e),tn(i)}),(function(o){!function(n,t,e,i){var o=w(t);en(t,e,i),N(t,e.class_error),A(t,p),O(e.callback_error,t,i),o||X(e,i)}(0,n,t,e),tn(i)}))},an=function(n,t,e){!function(n){n.llTempImage=document.createElement("IMG")}(n),on(n,t,e),function(n){S(n)||(n[_]={backgroundImage:n.style.backgroundImage})}(n),function(n,t,e){var i=I(n,t.data_bg),o=I(n,t.data_bg_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage='url("'.concat(r,'")'),M(n).setAttribute(l,r),B(n,t,e))}(n,t,e),function(n,t,e){var i=I(n,t.data_bg_multi),o=I(n,t.data_bg_multi_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage=r,function(n,t,e){N(n,t.class_applied),A(n,b),e&&(t.unobserve_completed&&z(n,t),O(t.callback_applied,n,e))}(n,t,e))}(n,t,e)},rn=function(n,t,e){!function(n){return W.indexOf(n.tagName)>-1}(n)?an(n,t,e):function(n,t,e){on(n,t,e),function(n,t,e){var i=Q[n.tagName];i&&(i(n,t),B(n,t,e))}(n,t,e)}(n,t,e)},cn=function(n){n.removeAttribute(l),n.removeAttribute(s),n.removeAttribute(f)},un=function(n){D(n,(function(n){H(n,P)})),H(n,P)},ln={IMG:un,IFRAME:function(n){H(n,F)},VIDEO:function(n){V(n,(function(n){H(n,F)})),H(n,j),n.load()}},sn=function(n,t){(function(n){var t=ln[n.tagName];t?t(n):function(n){if(S(n)){var t=U(n);n.style.backgroundImage=t.backgroundImage}}(n)})(n),function(n,t){L(n)||w(n)||(C(n,t.class_entered),C(n,t.class_exited),C(n,t.class_applied),C(n,t.class_loading),C(n,t.class_loaded),C(n,t.class_error))}(n,t),k(n),$(n)},fn=["IMG","IFRAME","VIDEO"],dn=function(n){return n.use_native&&"loading"in HTMLImageElement.prototype},_n=function(n,t,e){n.forEach((function(n){return function(n){return n.isIntersecting||n.intersectionRatio>0}(n)?function(n,t,e,i){var o=function(n){return x.indexOf(y(n))>=0}(n);A(n,"entered"),N(n,e.class_entered),C(n,e.class_exited),function(n,t,e){t.unobserve_entered&&z(n,e)}(n,e,i),O(e.callback_enter,n,t,i),o||rn(n,e,i)}(n.target,n,t,e):function(n,t,e,i){L(n)||(N(n,e.class_exited),function(n,t,e,i){e.cancel_on_exit&&function(n){return y(n)===g}(n)&&"IMG"===n.tagName&&(tn(n),function(n){D(n,(function(n){cn(n)})),cn(n)}(n),un(n),C(n,e.class_loading),R(i,-1),k(n),O(e.callback_cancel,n,t,i))}(n,t,e,i),O(e.callback_exit,n,t,i))}(n.target,n,t,e)}))},gn=function(n){return Array.prototype.slice.call(n)},vn=function(n){return n.container.querySelectorAll(n.elements_selector)},bn=function(n){return function(n){return y(n)===p}(n)},pn=function(n,t){return function(n){return gn(n).filter(L)}(n||vn(t))},hn=function(n,e){var o=c(n);this._settings=o,this.loadingCount=0,function(n,t){i&&!dn(n)&&(t._observer=new IntersectionObserver((function(e){_n(e,n,t)}),function(n){return{root:n.container===document?null:n.container,rootMargin:n.thresholds||n.threshold+"px"}}(n)))}(o,this),function(n,e){t&&window.addEventListener("online",(function(){!function(n,t){var e;(e=vn(n),gn(e).filter(bn)).forEach((function(t){C(t,n.class_error),k(t)})),t.update()}(n,e)}))}(o,this),this.update(e)};return hn.prototype={update:function(n){var t,o,a=this._settings,r=pn(n,a);T(this,r.length),!e&&i?dn(a)?function(n,t,e){n.forEach((function(n){-1!==fn.indexOf(n.tagName)&&function(n,t,e){n.setAttribute("loading","lazy"),on(n,t,e),function(n,t){var e=Q[n.tagName];e&&e(n,t)}(n,t),A(n,h)}(n,t,e)})),T(e,0)}(r,a,this):(o=r,function(n){n.disconnect()}(t=this._observer),function(n,t){t.forEach((function(t){n.observe(t)}))}(t,o)):this.loadAll(r)},destroy:function(){this._observer&&this._observer.disconnect(),vn(this._settings).forEach((function(n){$(n)})),delete this._observer,delete this._settings,delete this.loadingCount,delete this.toLoadCount},loadAll:function(n){var t=this,e=this._settings;pn(n,e).forEach((function(n){z(n,t),rn(n,e,t)}))},restoreAll:function(){var n=this._settings;vn(n).forEach((function(t){sn(t,n)}))}},hn.load=function(n,t){var e=c(t);rn(n,e)},hn.resetStatus=function(n){k(n)},t&&function(n,t){if(t)if(t.length)for(var e,i=0;e=t[i];i+=1)u(n,e);else u(n,t)}(hn,window.lazyLoadOptions),hn}));

},{}],2:[function(require,module,exports){
"use strict";

var _functions = require("./moduls/functions");

var _functions2 = _interopRequireDefault(_functions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init_first = function init_first() {
    _functions2.default.lazy_load();
    _functions2.default.lazy_load();
    _functions2.default.search();
    _functions2.default.close_mega_menu();
    _functions2.default.expand_and_collapse(".header__burger", ".header__nav", "-", "active");
    _functions2.default.expand_and_collapse(".header__mobile-close", ".header__nav", "active", "active");

    _functions2.default.expand_and_collapse(".for_desc", ".header__megamenu", "active", "active");
    _functions2.default.expand_and_collapse(".any", ".header__list", "active", "active");

    _functions2.default.expand_and_collapse(".header__search .icon", ".header__search", "active", "active");
    _functions2.default.no_scroll();
    //tabs
    _functions2.default.matches_tabs(".switch1", ".inside-tab2");
    _functions2.default.matches_tabs(".summary-box__tab", ".single-match__tab-content");
    _functions2.default.matches_tabs(".switch2", ".tab-switch2");
    _functions2.default.matches_tabs(".table-tabs__tab", ".table-switch-content");
    _functions2.default.matches_tabs(".player-stat-tab", ".player-stat");
    _functions2.default.matches_tabs(".switch3", ".inside-tab");
    _functions2.default.matches_tabs(".matches-switcher__tab", ".team-matches-switch");
    _functions2.default.expand_and_collapse(".survey__show", ".survey__switch", "active", "active");

    _functions2.default.expand_and_collapse(".single-story__open-share", ".social-share-story", "active", "active");

    _functions2.default.select_to_redirect(".comp-select-season", false);

    _functions2.default.search();

    // var pair_seen = document.querySelectorAll(".pair-seen");
    // console.log(pair_seen.childElement)

    _functions2.default.pridection_profile_tab();
    _functions2.default.handel_fixed_aside();
    _functions2.default.save_expectation();
    _functions2.default.pair_seen();
    _functions2.default.removelinkmob();
    _functions2.default.switcher();
    _functions2.default.resizing();
    _functions2.default.activeTab();
};

var body = document.getElementsByTagName("body")[0];
body.addEventListener("load", init_first(), false);

},{"./moduls/functions":3}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vanillaLazyload = require("vanilla-lazyload");

var _vanillaLazyload2 = _interopRequireDefault(_vanillaLazyload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var functions = {};

if (window.outerWidth < 820) {
    document.querySelector('.header__more-links').classList.add("for_desc");
}

functions.close_mega_menu = function () {
    if (document.querySelector('.close-mega-menu')) {
        var close = document.querySelector('.close-mega-menu'),
            more = document.querySelector('.header__more-links'),
            menu_body = document.querySelector('.header__megamenu');
        close.onclick = function () {
            more.classList.remove('active');
            menu_body.classList.remove('active');
        };
    }
};
functions.no_scroll = function () {
    if (document.querySelector('header')) {
        var _nav = document.querySelector('.header__nav'),
            _header = document.querySelector('header'),
            html = document.querySelector('html');
        // _mega = document.querySelector('.header__more-links');
        _header.addEventListener('click', function () {
            if (_nav.classList.contains('active')) {
                html.classList.add('no-scrl');
            } else {
                html.classList.remove('no-scrl');
            }
        });
    }
};
//     // -- toggle active 2 elements or 1 element if founded
functions.expand_and_collapse = function (el_1, el_2, class_1, class_2) {
    el_1 = document.querySelector(el_1);
    if (el_1 && el_2) {
        el_1.onclick = function () {
            el_1.classList.toggle(class_1);
            document.querySelector(el_2).classList.toggle(class_2);
        };
    } else if (el_1 && !el_2) {
        el_1.onclick = function () {
            el_1.classList.toggle(class_1);
        };
    } else {}
};

functions.matches_tabs = function (_tab, _content) {
    var tab = document.querySelectorAll(_tab);

    if (tab) {
        (function () {
            var content = document.querySelectorAll(_content);

            var _loop = function _loop(i) {
                tab[i].onclick = function () {
                    for (var x = 0; x < tab.length; x++) {

                        tab[x].classList.remove('active');
                        content[x].classList.remove('active');
                    }
                    tab[i].classList.add('active');
                    content[i].classList.add('active');
                };
            };

            for (var i = 0; i < tab.length; i++) {
                _loop(i);
            }
        })();
    }
};

functions.lazy_load = function () {
    var lazyLoadInstance = new _vanillaLazyload2.default({
        // Your custom settings go here
    });
};

functions.search = function () {

    var searchInput = document.querySelector('.header__search-box input'),
        submit = document.querySelector('.enter-search');
    if (searchInput) {
        searchInput.onsearch = function () {
            if (searchInput.value.length > 2) {

                window.location.href = "/Search?q=" + helper.spaceToDash(searchInput.value);
            }
        };
    }
    if (submit) {
        submit.onclick = function () {
            if (searchInput.value.length > 2) {
                window.location.href = "/Search?q=" + helper.spaceToDash(searchInput.value);
            }
        };
    }
};
functions.select_to_redirect = function (_input, has_id) {

    var radio_btn = document.querySelectorAll(_input);
    // _link = radio_btn.getAttribute(`data-url`)

    var _loop2 = function _loop2(i) {
        radio_btn[i].addEventListener("change", function () {
            // e.preventDefault()
            if (has_id == false) {
                location.href = radio_btn[i].getAttribute('data-url');
            } else {
                location.href = radio_btn[i].getAttribute('last-season-url');
            }
        });
    };

    for (var i = 0; i < radio_btn.length; i++) {
        _loop2(i);
    }
};

functions.pridection_profile_tab = function () {
    if (document.querySelector(".tab-btn")) {
        var buttons = document.querySelectorAll(".tab-btn");
        var articleContainer = document.querySelector(".article-container");
        var articles = document.querySelectorAll(".content");
        articleContainer.addEventListener("click", function (e) {
            var id = e.target.dataset.id;
            if (id) {
                //iterate through buttons to remove & add class
                buttons.forEach(function (button) {
                    button.classList.remove("active");
                    e.target.classList.add("active");
                });
                //iterate through articles to remove & add class
                articles.forEach(function (article) {
                    article.classList.remove("active");
                });
                var element = document.getElementById(id);
                element.classList.add("active");
            }
        });
    }
};

// Elgndy
functions.handel_fixed_aside = function () {
    if (document.querySelector(".sticky-box")) {
        var layout__item = document.querySelector(".layout__item");
        var sticky_box = document.querySelector(".sticky");
        var num = 0;
        if (sticky_box.childElementCount > 1) {
            num = 450;
        }

        window.addEventListener("scroll", function () {
            if (window.outerWidth > 820) {
                if (window.pageYOffset > layout__item.scrollHeight - document.querySelector(".footer").clientHeight - num) {
                    sticky_box.style.position = 'absolute';
                    sticky_box.style.bottom = '-40px';
                    sticky_box.style.top = 'inherit';
                } else {
                    sticky_box.style.position = 'fixed';
                    sticky_box.style.top = '40';
                    sticky_box.style.bottom = 'inherit';
                }
            }
        });
    }
};

functions.save_expectation = function () {
    var card_saving = document.querySelectorAll('.card-saving button');
    var wrrap_for_bac = document.querySelector('.wrrap-for-bac');
    var pair_modal = document.querySelector('.pair-modal');
    var modal_head = document.querySelectorAll('.modal-head  span');
    var empty_value = document.querySelector('.empty-value');

    card_saving.forEach(function (ele) {
        ele.addEventListener('click', function () {
            var inputs = ele.parentElement.parentElement.querySelector('.card-score').querySelector('.card-numbers').querySelector('.rate-flex').querySelectorAll('input');

            if (inputs[0].value != '' && inputs[1].value != '') {
                wrrap_for_bac.style.display = 'flex';
                setTimeout(function () {
                    wrrap_for_bac.querySelector('.pair-modal').style.opacity = '1';
                }, 200);
            } else {
                empty_value.style.display = 'flex';
                setTimeout(function () {
                    empty_value.querySelector('.pair-modal').style.opacity = '1';
                }, 200);
            }

            // console.log(ele.parentElement.parentElement.querySelector('.card-score').querySelector('.card-numbers').querySelector('.rate-flex').querySelectorAll('input'))
            document.querySelector('html').classList.add('no-scrl');
        });
    });
    // clse modal
    modal_head.forEach(function (ele) {
        ele.addEventListener('click', function () {
            pair_modal.style.opacity = '0';
            setTimeout(function () {
                wrrap_for_bac.style.display = 'none';
                empty_value.style.display = 'none';
            }, 200);
            document.querySelector('html').classList.remove('no-scrl');
        });
    });
};

// switch input type in register between seen and unseen
functions.pair_seen = function () {
    var pair_seen_seen = document.querySelectorAll(".pair-seen svg");
    var pair_seen_unseen = document.querySelectorAll(".pair-seen img");
    pair_seen_seen.forEach(function (ele) {
        ele.addEventListener("click", function () {
            ele.classList.add("notactive");
            ele.nextElementSibling.classList.remove("notactive");
            ele.parentElement.firstElementChild.setAttribute("type", "text");
        });
    });
    pair_seen_unseen.forEach(function (ele) {
        ele.addEventListener("click", function () {
            ele.classList.add("notactive");
            ele.previousElementSibling.classList.remove("notactive");
            ele.parentElement.firstElementChild.setAttribute("type", "password");
        });
    });
};

functions.removelinkmob = function () {
    if (document.querySelector(".removelinkmob") && window.outerWidth <= 1222) {
        var removelinkmob = document.querySelector(".removelinkmob");
        removelinkmob.setAttribute("href", "#");
    }
};

functions.switcher = function () {
    var switch_login_btn = document.getElementById("switch-login_btn");
    var switch_profile_div = document.getElementById("switch_profile_div");
    if (window.location.pathname.includes('/index-logined') || window.location.pathname.includes('/comptation-card-info') || window.location.pathname.includes('/profile-data')) {
        if (window.outerWidth < 1222) {
            switch_profile_div.style.display = 'flex ';
        }

        switch_login_btn.innerHTML = "\n        <svg class=\"bi bi-power\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" viewbox=\"0 0 16 16\">\n          <path d=\"M7.5 1v7h1V1h-1z\"></path>\n          <path d=\"M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z\"></path>\n        </svg>\u062A\u0633\u062C\u064A\u0644 \u062E\u0631\u0648\u062C \n        ";
        switch_login_btn.href = 'login.html';
        switch_login_btn.querySelector("svg").style.display = 'block';
    }

    if (window.location.pathname.includes('/login') || window.location.pathname.includes('/register') || window.location.pathname.includes('/forgetpass') || window.location.pathname.includes('/Verification')) {
        if (window.outerWidth >= 1222) {
            document.getElementById("for-switch").href = 'index.html';
        }
    }
};

functions.resizing = function () {
    if (document.querySelector('.register_edit') && window.outerWidth >= 1000 && window.outerWidth <= 1222) {
        var register_edit = document.querySelector('.register_edit');
        register_edit.style.width = window.outerWidth - 100 + "px";
    }
};

functions.activeTab = function () {
    if (document.querySelectorAll('.header__list a')) {
        var header__list = document.querySelectorAll('.header__list a');
        if (!window.location.pathname.includes('/login') || !window.location.pathname.includes('/register') || !window.location.pathname.includes('/forgetpass') || !window.location.pathname.includes('/Verification')) {
            header__list[0].href = 'index-logined.html';
        }
        if (window.location.pathname.includes('/login') || window.location.pathname.includes('/register') || window.location.pathname.includes('/forgetpass') || window.location.pathname.includes('/Verification')) {
            header__list[0].href = 'index.html';
        }
        if (window.location.pathname.includes('/index.html')) {
            header__list[0].href = 'index.html';
        }
        header__list.forEach(function (ele) {
            if (window.location.href.includes(ele.href)) {
                ele.classList.add('active');
            }
        });
    }

    console.log(header__list);
};

exports.default = functions;

},{"vanilla-lazyload":1}]},{},[2]);
